import { ReactNode } from 'react';

interface IChatsSectionProps {
  isLoading: boolean;
  hasChats: boolean;
  hasVisibleChats: boolean;
  isUnreadFilterEnabled: boolean;
  children: ReactNode;
}

/** Умный раздел списка клиентских чатов. */
export function ChatsSection({
  isLoading,
  hasChats,
  hasVisibleChats,
  isUnreadFilterEnabled,
  children
}: IChatsSectionProps) {
  if (isLoading && !hasChats) {
    return (
      <div className="telegram-chat-list__placeholder">
        <span className="telegram-chat-list__pulse" aria-hidden="true" />
        <strong>Загружаем чаты</strong>
        <p>Подготавливаем актуальный список переписок.</p>
      </div>
    );
  }

  if (!isLoading && !hasChats) {
    return (
      <div className="telegram-chat-list__placeholder">
        <span className="telegram-chat-list__pulse" aria-hidden="true" />
        <strong>Список чатов пока пуст</strong>
        <p>Новые диалоги из Telegram и MAX появятся здесь автоматически.</p>
      </div>
    );
  }

  if (hasChats && !hasVisibleChats) {
    return (
      <div className="telegram-chat-list__placeholder telegram-chat-list__placeholder--compact">
        <strong>{isUnreadFilterEnabled ? 'Непрочитанных чатов нет' : 'Ничего не найдено'}</strong>
        <p>{isUnreadFilterEnabled ? 'Отключите фильтр или дождитесь новых сообщений.' : 'Измените строку поиска, чтобы увидеть подходящие диалоги.'}</p>
      </div>
    );
  }

  return <div className="telegram-chat-list__items">{children}</div>;
}
